// SafeEnvironmentSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import safeEnvironmentImage from '../assets/safe-environment-image.jpg';

const SafeEnvironmentSection = () => {
  return (
    <section className="bg-bnCream py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              A Safe Home
            </p>
            <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Creating a Safe and Supportive Environment for Dementia Care
            </h2>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-10">
              <p>
                At B & N Enterprise, we place real importance on creating a safe and supportive environment for people living with dementia. The right surroundings make a genuine difference to wellbeing, helping to ease anxiety and improve quality of life. Our team is committed to thoughtful strategies and home adjustments that keep the people we support safe and comfortable.
              </p>

              <p>
                Safety is paramount when it comes to dementia care. We conduct a comprehensive assessment of the home environment to identify potential hazards and implement necessary modifications. We address issues such as removing tripping hazards, installing handrails, and improving lighting to reduce the risk of falls. Our carers across Canberra and the surrounding ACT are trained to offer gentle guidance and reassurance, helping to ease anxiety and build a sense of security.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-bnAccent hover:bg-bnAccentDark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call +61 480 804 640
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={safeEnvironmentImage}
              alt="A carer supporting an older woman at home"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafeEnvironmentSection;
